'use client';

import { loginUser } from '@/lib/loginUser';
import { AuthenticateProps } from 'shared-components';
import { Authenticate } from './Authenticate';

export const LoginUserForm = ({
  onDone,
  inverseAction,
}: {
  onDone: () => void;
} & Pick<AuthenticateProps, 'inverseAction'>) => {
  return (
    <Authenticate
      context='login'
      title='Inicia sesión'
      description='Recibe y gestiona órdenes de trabajo desde un solo lugar.'
      back={{
        label: 'Volver al login',
      }}
      submit={{
        label: 'Iniciar sesión',
        handle: (data) => loginUser(data),
        forceVerification: false,
      }}
      callbacks={{
        onDone,
      }}
      inverseAction={inverseAction}
    />
  );
};
